import { GRID_DENSITIES, type GridDensity } from "./grid-density";
import { useGridDensity } from "./GridDensityContext";

const LABELS: Record<GridDensity, string> = {
  1: "1 карточка в строке",
  2: "2 карточки в строке",
  3: "3 карточки в строке",
};

function ColumnIcon({ columns }: { columns: GridDensity }) {
  return (
    <span className={`hw-grid-icon hw-grid-icon--${columns}`} aria-hidden="true">
      {Array.from({ length: columns }, (_, index) => (
        <span key={index} />
      ))}
    </span>
  );
}

export function GridDensityToggle() {
  const { density, setDensity } = useGridDensity();

  return (
    <div className="hw-grid-toggle" role="radiogroup" aria-label="Карточек в строке">
      {GRID_DENSITIES.map((value) => {
        const active = density === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            className={
              active ? "hw-grid-toggle__btn hw-grid-toggle__btn--active" : "hw-grid-toggle__btn"
            }
            aria-checked={active}
            aria-label={LABELS[value]}
            onClick={() => setDensity(value)}
          >
            <ColumnIcon columns={value} />
          </button>
        );
      })}
    </div>
  );
}
